import VueRouter from 'vue-router'
import Home from '../components/pages/Home.vue'
import ExamTestMain from '../../client/components/pages/ExamTestMain.vue'
import ExamShow from '../../client/components/pages/ExamTestShow.vue'
import ExamTestQuestionList from '../../client/components/pages/ExamTestQuestionList.vue'
import ExamResult from '../../client/components/pages/ExamResult.vue'
import ExamResultQuestionList from '../../client/components/pages/ExamResultQuestionList.vue'
import ExamResultMain from '../../client/components/pages/ExamResultMain.vue'
import { setupExamRouterHistories } from '../../client/utils/setup_exam_router'

export const EMBED_ROUTER_NAME = {
  HOME: 'home',
  EXAM_SHOW: 'exam-show',
  QUESTION: 'question',
  EXAM_QUESTION_LIST: 'exam-question-list',
  EXAM_RESULT: 'exam-result',
  EXAM_RESULT_QUESTION_LIST: 'exam-result-question-list',
  ANSWER_RESULT_DETAIL: 'answer-result-detail',
}

const routes = [
  {
    path: '/embed/my-exams/:examId/',
    component: ExamShow,
    name: EMBED_ROUTER_NAME.EXAM_SHOW,
    meta: {
      transitionName: 'slide',
      index: 1,
      title: 'テスト詳細',
      embed: true
    }
  },
  {
    path: '/embed/my-exams/:examId/questions/:questionId/',
    component: ExamTestMain,
    name: EMBED_ROUTER_NAME.QUESTION,
    meta: {
      transitionName: 'slide',
      index: 1,
      title: 'テスト',
      embed: true
    }
  },
  {
    path: '/embed/my-exams/:examId/question-list/',
    component: ExamTestQuestionList,
    name: EMBED_ROUTER_NAME.EXAM_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 2,
      title: '問題一覧',
      embed: true
    }
  },
  {
    path: '/embed/my-exams/:examId/result/',
    component: ExamResult,
    name: EMBED_ROUTER_NAME.EXAM_RESULT,
    meta: {
      transitionName: 'slide',
      index: 3,
      title: 'テスト結果',
      embed: true
    }
  },
  {
    path: '/embed/my-exams/:examId/result/question-list',
    component: ExamResultQuestionList,
    name: EMBED_ROUTER_NAME.EXAM_RESULT_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 3,
      title: '問題一覧',
      embed: true
    }
  },
  {
    path: '/embed/my-exams/:examId/result/questions/:questionId/',
    component: ExamResultMain,
    name: EMBED_ROUTER_NAME.ANSWER_RESULT_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: '回答',
      embed: true
    }
  },
  {
    path: '/embed/*/:targetId',
    component: Home,
    name: EMBED_ROUTER_NAME.HOME,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'ダッシュボード',
      embed: true
    },
  },
]

export const vueRouter = new VueRouter({
  routes,
  mode: 'history'
})

setupExamRouterHistories(
  vueRouter, 
  [
    EMBED_ROUTER_NAME.EXAM_SHOW
  ]
)